<div
  (click)="promptItemSelection(true)"
  class="visionboard-template-lane-item"
  [ngClass]="{ acceptsInput: acceptsInput }"
  [matTooltip]="tooltipText"
  matTooltipShowDelay="3000"
  matTooltipPosition="above"
>
  <div
    class="item-wrapper"
    *ngIf="item"
    (mouseover)="toggleControls(true)"
    (mouseleave)="toggleControls(false)"
  >
    <div
      class="orderable"
      *ngIf="item && isOrderable && hasOrderManagement"
      matTooltip="Orderable"
    >
      <mat-icon
        class="orderable-icon"
        svgIcon="shopping_bag"
      ></mat-icon>
    </div>
    <span
      class="venue-provided"
      *ngIf="isVenueProvided"
      >{{ venueProvidedLabel | uppercase }}</span
    >
    <img
      class="item-image"
      src="{{ item.searchThumbnail }}"
      imgErrLog
    />
    <app-visionboard-item-controls-container
      [isHovered]="isHovered"
      [item]="item"
      source="Category View Template Lane Item"
      [showMoreActionsMenu]="showMoreActionsMenu"
    ></app-visionboard-item-controls-container>
  </div>
  <mat-icon
    svgIcon="plus"
    class="plus-icon"
    *ngIf="!item && acceptsInput"
  ></mat-icon>
  <span
    #multiSubCategoryTrigger
    class="trigger"
    [matMenuTriggerFor]="menu"
    *ngIf="multiSubCatMode"
  ></span>
  <span
    #nestedMultiSubCategoryTrigger
    class="trigger"
    [matMenuTriggerFor]="nestedMenu"
    *ngIf="lane.useNestedMenu"
  ></span>
</div>

<mat-menu #menu="matMenu">
  <button
    class="sub-cat-button"
    mat-menu-item
    *ngFor="let key of subCategoryKeys"
    (click)="onSubCatClick(key)"
  >
    <span>{{ key[1] }}</span>
  </button>
</mat-menu>

<mat-menu #nestedMenu="matMenu">
  <ng-container *ngFor="let categoryKey of nestedSubCategoryKeys">
    <button
      class="sub-cat-button"
      mat-menu-item
      [matMenuTriggerFor]="subCategoryMenu"
    >
      {{ categoryKey[0] }}
    </button>
    <mat-menu
      #subCategoryMenu="matMenu"
      class="visionboard-workspace-template-lane-item-nested-sub-cat-menu"
    >
      <button
        *ngFor="let subCategory of categoryKey[1]"
        mat-menu-item
        class="sub-cat-button"
        (click)="onSubCatClick([categoryKey[0], subCategory])"
      >
        {{ subCategory }}
      </button>
    </mat-menu>
  </ng-container>
</mat-menu>
